import { AlpineComponent } from 'alpinejs';

import {
  localStorageEvents,
  getLocalWatchlistCount
} from '../../javascripts/helpers/localstorage';

const classes = {
  showCount: 'watch-list-link--show-count'
};

const WatchListLink = (): AlpineComponent => ({
  count: 0,
  updateCount() {
    this.count = getLocalWatchlistCount();
    if (this.count) {
      this.$root.classList.add(classes.showCount);
    } else {
      this.$root.classList.remove(classes.showCount);
    }
  },
  init() {
    this.updateCount();

    window.addEventListener(localStorageEvents.updated, () => {
      this.updateCount();
    });
  }
});

export default WatchListLink;
